
export const STEP_ONE: any = {
  flow_slug: 'memberValidationFlow',
  flow_version: 1,
  uuid: 'member_validation_flow_step_two',
  heading: 'Link your policy to your British Airways Club account and start collecting Avios',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Link now'
  },
  sections: [
    {
      uuid: 'link_section',
      layout: '',
      settings: {
        size: 'small'
      },
      elements: [
        {
          uuid: 'last_name',
          layout: '',
          settings: {
            disabled: true
          },
          prompt: 'Last name',
          key: 'last_name',
          type: 'string',
          required: true
        },
        {
          uuid: 'avios_member_number',
          layout: '',
          settings: {},
          prompt: 'Executive Club account number',
          key: 'avios_member_number',
          type: 'string',
          required: true
        }
      ]
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'member_validation_flow_step_two'
    },
    last_name: ''
  },
  human: {
    last_name: ''
  },
  progress: 1,
  total_pages: 2,
  actions: {
    next: {}
  },
  analytics: {
    flow_slug: 'memberValidationFlow',
    flow_version: 1,
    page_uuid: 'member_validation_flow_step_one'
  }
};

export const STEP_TWO: any = {
  heading: 'Your policy is now linked',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Back to my dashboard',
    hide_cta: true
  },
  sections: [
    {
      uuid: 'link_section',
      layout: '',
      settings: {
        size: 'medium'
      },
      elements: [],
      info: {
        settings: {
          align: 'under_heading'
        },
        content: '<p>Your membership number has been successfully validated, and your policy is now linked to your British Airways Club account.</br>If you’re eligible, your account should be credited with Avios. It may take up to 45 days for the Avios to appear in your member’s statement. Read our {{ termsLink }} to learn about Avios Award.</p>' 
      }
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'member_validation_flow_step_two'
    },
    last_name: ''
  },
  human: {
    last_name: ''
  },
  progress: 2,
  total_pages: 2,
  actions: {
    next: {},
    jumps: {
      default: {
        label: 'Back to my dashboard'
      }
    }
  },
  analytics: {
    flow_slug: 'memberValidationFlow',
    flow_version: 1,
    page_uuid: 'member_validation_flow_step_two'
  }
}
